import axios from 'axios';
// eslint-disable-next-line
import { request } from '@user/api/helpers/sendRequest';

export const urls = {
  getData: '/api/dashboardHome',
  profile: '/api/profile',
};

export function accountActivation(userIdHash) {
  return axios.post('/api/accountActivation', { userIdHash });
}

export function changePassword(options) {
  return request.send('/api/changeUserPassword', 'post', { data: options });
}

export async function fetchDataProtStatement(options) {
  const query = `/api/${options.cstm}/dataProtStat/1/${options.language}`;
  try {
    const response = await axios.get(query);
    return { response };
  } catch (error) {
    return { error };
  }
}

export function fetchReport(profileId) {
  return request.send(
    '/api/createReport',
    'post',
    { profileId },
    { responseType: 'blob' }
  );
}

export function fetchReportBindings(profileId) {
  return request.send(
    '/api/getReportBindingsWithScalesAndUserComponentStatus',
    'post',
    { profileId }
  );
}

export function finalizeApplication() {
  return request.send('/api/finalizeApplication', 'post', {});
}

export function customSubmit(url, payload) {
  return request.send(url, 'post', payload);
}
export function submitForm(formularIdentifier, payload) {
  return request.sendWithoutToken(
    `/api/formData/${formularIdentifier}`,
    'post',
    payload
  );
}
export function loadFormData(formularIdentifier) {
  return request.send(`/api/formData/${formularIdentifier}?raw=true`);
}
export function getProjectForms() {
  return request.send(`/api/getProjectForms`);
}

export function loadData(profileId) {
  return request.send(`${urls.getData}/${profileId}`);
}

export function loadUserData() {
  return request.send('/api/userData');
}

export function loadProfiles() {
  return request.send('/api/profiles');
}

export function loadProjectConfiguration(urlparm) {
  return request.sendWithoutToken(`/api/getConfiguration${urlparm}`);
}

export function loginOnSiteUser({ payload }) {
  return request.sendWithoutToken('/api/onSiteLogin', 'post', payload);
}

export function loginUser({ payload }) {
  return request.sendWithoutToken('/api/login', 'post', payload);
}

export function registerUser(options) {
  return request.sendWithoutToken('/api/register', 'post', options);
}
export function registerAnon(options) {
  return request.sendWithoutToken('/api/registerAnon', 'post', options);
}
export function requestSessionURL(prcmId, profileId) {
  return request.sendWithoutToken('/api/initPicat', 'post', {
    sessionData: { prcm_id: prcmId, profileId },
  });
}

export function resetPassword(options) {
  return request.sendWithoutToken('/api/resetPassword', 'post', options);
}

export function resetPasswordByUserName(options) {
  return request.sendWithoutToken(
    '/api/resetPasswordByUserName',
    'post',
    options
  );
}

export async function getPasswordRequirementsForSelfRegister(options) {
  return request.sendWithoutToken(
    '/api/getPasswordRequirementsForSelfRegister',
    'post',
    options
  );
}

export async function getPasswordRequirementsByUserHash(options) {
  return request.sendWithoutToken(
    '/api/getPasswordRequirementsByUserHash',
    'post',
    options
  );
}

export function getPasswordRequirementsByUserId(options) {
  return request.send('/api/getPasswordRequirementsByUserId', 'post', options);
}

export function saveNewPassword(options) {
  return request.sendWithoutToken('/api/saveNewPassword', 'post', options);
}

export function logout() {
  return request.send('/api/logout');
}

export async function saveProfile(data) {
  try {
    const response = await request.send('/api/profile', 'post', data);
    return { response };
  } catch (error) {
    return { error };
  }
}

export function sendFeedback(feedback) {
  return request.send('/api/postUserFeedback', 'post', feedback);
}

export function setModuleFinished(prcmId) {
  return request.send('/api/finishComponent', 'post', {
    componentId: prcmId,
  });
}

/**
 * Setzt alle zum FBO-Container gehörende Module auf "finished"
 * @param {array} moduleIds
 * @returns {object}
 */
export function setFBOModulesFinished(moduleIds) {
  return request.send('/api/finishFBOComponents', 'post', {
    moduleIds,
  });
}

export function updatePassword(options) {
  return request.send('/api/saveNewPassword', 'post', options);
}

export async function loadModuleContainers(profileId) {
  /** Temporärer workaround, später Elements direkt in API response liefernin response */
  try {
    const res = await request.send(`/api/dashboardHome/container/${profileId}`);
    return res;
  } catch (error) {
    return { error };
  }
  /* const res1 = await loadData(profileId);
  const res2 = await loadData(10);
  console.log('res2');
  console.log(res2);

  return {
    language: res1.language,
    containers: [
      {
        name: 'TestContainer 1',
        id: 5555,
        description: 'Description 1',
        size: 5,
        iconPath: 'IconGewinnspiel',
        elements: res1.elements, // TODO MVP1: Hier echte elements + durations
        finishedElements: res1.finishedElements,
        type: 'fbo',
      },
      {
        name: 'TestContainer 2',
        id: 5556,
        description: 'Description 2',
        size: 2,
        iconPath: 'IconFAQ',
        elements: res2.elements, // TODO MVP1: Hier echte elements + durations
        finishedElements: res2.finishedElements,
        type: 'test',
      },
      // {
      //   name: 'TestContainer 3',
      //   id: 5557,
      //   description: 'Description 3 (Training)',
      //   size: 2,
      //   icon: 'TestIcon',
      //   elements: res.elements, // TODO MVP1: Hier echte elements + durations
      //   finishedElements: res.finishedElements,
      //   type: 'training',
      // },
    ],
  }; */
}
export function trackPicatNavigation(profileId) {
  return request.send('/api/trackPicatNavigation', 'post', {
    profileId,
  });
}

export function trackFormAction(profileId) {
  return request.send('/api/trackFormAction', 'post', {
    profileId,
  });
}

export function trackVideoAction(profileId) {
  return request.send('/api/trackVideoAction', 'post', {
    profileId,
  });
}
